import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LegacyDetailRedirect, detailNavState } from '../../components/detail';
import { parseRouteId } from '../../utils/routeId';
import { quotationDetailPath, quotationEditPath } from '../../utils/quotationDetailRoute';

/**
 * ลิงก์เก่าของหน้ารายการใบเสนอราคาสมัยโมดัล → หน้าเต็ม (ครอบ element ของ route รายการใน App.tsx)
 *   `?open=<id>` (ลิงก์ในแชท/คู่มือ ก่อน 28 ต.ค. 2026) และ `?view=` / `?edit=` (แพตเทิร์นกลาง LegacyDetailRedirect)
 * ตัวกรองอื่นที่ติดมาใน query ถูกเก็บเป็น `from` ให้ปุ่มกลับของหน้ารายละเอียด · id ใช้ไม่ได้ = ตัดทิ้ง อยู่หน้ารายการ
 */
const QuotationLegacyRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const openRaw = params.get('open');
  if (openRaw !== null) {
    params.delete('open');
    const restSearch = params.toString() ? `?${params.toString()}` : '';
    const id = parseRouteId(openRaw);
    if (id === null) return <Navigate to={`${location.pathname}${restSearch}`} replace />;
    return (
      <Navigate
        to={quotationDetailPath(id)}
        replace
        state={detailNavState({ pathname: location.pathname, search: restSearch })}
      />
    );
  }
  return (
    <LegacyDetailRedirect view={quotationDetailPath} edit={quotationEditPath}>
      {children}
    </LegacyDetailRedirect>
  );
};

export default QuotationLegacyRedirect;
